export default __webpack_public_path__ + "static/media/radio-checked.412d2043.svg";